import React from "react";
import styled from "styled-components";
import { COLOR_GRAY_BACKGROUND } from "../../constants/color";

type Props = {
  title: string;
  value: number;
};

export const Card: React.FC<Props> = ({ title, value }) => (
  <CardContainer>
    <CardTitle>{title}</CardTitle>
    <CartValue>{value}</CartValue>
  </CardContainer>
);

const CardContainer = styled.div`
  background-color: ${COLOR_GRAY_BACKGROUND};
  border-radius: 8px;
  padding: 20px 24px;
  min-width: 220px;
  min-height: 90px;
  box-sizing: border-box;
  box-shadow: none;

  @media (max-width: 768px) {
    min-width: auto;
    min-height: 80px;
    padding: 16px 20px;
  }

  @media (max-width: 480px) {
    min-height: 70px;
    padding: 14px 16px;
  }
`;

const CardTitle = styled.div`
  color: #7b7f87;
  font-size: 16px;
  margin-bottom: 8px;

  @media (max-width: 768px) {
    font-size: 14px;
    margin-bottom: 6px;
  }

  @media (max-width: 480px) {
    font-size: 13px;
    margin-bottom: 4px;
  }
`;

const CartValue = styled.div`
  font-weight: 600;
  font-size: 28px;

  @media (max-width: 768px) {
    font-size: 24px;
  }

  @media (max-width: 480px) {
    font-size: 20px;
  }
`;
